import { getGlsBaseUrl } from '@/api/gls/get-gls-base-url';

/**
 * Builds the FGP net-position endpoint from the region-aware GLS base
 * (map-first via {@link getGlsBaseUrl}, so Canada resolves to the prod host on
 * darklive/prod instead of falling back to the cert host). Returns `null` when
 * no GLS base is configured so callers treat it as a skipped call.
 */
export const getNetPositionEndpoint = (): string | null => {
  let base: string;

  try {
    base = getGlsBaseUrl();
  } catch {
    return null;
  }

  if (!base) {
    return null;
  }

  const trimmedBase = base.endsWith('/') ? base.slice(0, -1) : base;

  return `${trimmedBase}/cfg/api/v1/netPosition`;
};
